import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '@app/services/authentication.service';
import { NeoTableService } from '../components/neo-table/neo-table.service';

@Pipe({
    name: 'neoShortDate',
    standalone: false
})
export class NeoShortDatePipe implements PipeTransform {
  constructor(private authService: AuthenticationService) { }
  /* This pipe converts the input date value according to the current Locale and Timezone.
     Input -> (date|string) -> "2022-10-17T05:57:07.8619924"
     Output -> (string) -> "10/17/2022" */
  transform(value?: Date | string): string {
    if (!value) return '';
    const userTimezone = this.authService.getActiveUser()?.extensionTimezoneId || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = navigator.language;
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      timeZone: userTimezone,
    };
    const isoDateStr = NeoTableService.getISODatetimeString(value);
    return `${(new Date(isoDateStr)).toLocaleString(locale, options)}`;
  }
}
